<template>
    <el-autocomplete
        :value="value"
        @input="handleChange"
        @select="handleSelect"
        size="mini"
        :fetch-suggestions="addressSearch"
        :trigger-on-focus="true"
        :popper-class="dropdownClass"
        :title="value"
    >
        <template slot-scope="{ item }">
            <div class="value" :title="item.value">
                {{ item.value }}
            </div>
        </template>
    </el-autocomplete>
</template>

<script>
export default {
    name: 'AddressAutocomplete',
    props: {
        value: {
            type: String,
            default: ''
        },
        dropdownClass: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleSelect(value) {
            this.$emit('handleCoordinates', value.coordinates);
        },
        handleChange(value) {
            this.$emit('input', value);
        },
        addressSearch(queryString, callback) {
            const searchResult = [];
            const apiKey = this.$store.getters.yandexApiKey;
            fetch('https://geocode-maps.yandex.ru/1.x/?apikey=' + apiKey + '&format=json&geocode=' + ('Москва ' + queryString), {
                method: 'get'
            }).then((resp) => resp.json()).then((data) => {
                const places = data.response.GeoObjectCollection.featureMember;
                places.forEach((place) => {
                    let postal = '';
                    if (place.GeoObject.metaDataProperty.GeocoderMetaData.Address.postal_code) {
                        postal = place.GeoObject.metaDataProperty.GeocoderMetaData.Address.postal_code + ', ';
                    }
                    searchResult.push({
                        label: place.GeoObject.description + ' - ' + place.GeoObject.name,
                        value: postal + place.GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted,
                        coordinates: place.GeoObject.Point.pos.split(' ').reverse().join(' ')
                    });
                });
                callback(searchResult);
            }).catch((error) => {
                console.log(error);
                callback(searchResult);
            });
        }
    }
};
</script>
